import React from 'react';
import { useParams } from 'react-router-dom';

import DangerousHTMLContainer from 'components/DangerousHTMLContainer';
import { useTrackNTraceCode } from 'helpers/portal';

type RouteProps = {
  lang: string;
  companyId: UUIDField;
  pageId: string;
};

function TrackNTrace() {
  const { lang, companyId, pageId } = useParams<RouteProps>();
  const trackNTraceCode = useTrackNTraceCode(pageId!, lang!);
  return <DangerousHTMLContainer html={trackNTraceCode} />;
}

export default TrackNTrace;
